import { useState } from "react";
import { Button, Col, Modal, Row, Input, Alert } from "reactstrap";
import CSVImporter from "../CRM/CSVImporter";
import IconButton from "../../elements/IconButton";

interface Props {
  open: boolean;
  onClose: () => void;
  importData: (data: any) => void;
  submitting: boolean;
  error: string | null;
}

export default function ImportCSVModal({
  open,
  onClose,
  importData,
  submitting,
  error,
}: Props) {
  const [csvData, setCsvData] = useState<any>(null);

  const storeCsvData = (data: any) => {
    const finalData = data.flatMap((item: any) => {
      if (!item.Name || !item.Value) return [];

      item.Type = "string";

      return [item];
    });

    setCsvData(finalData);
  };

  const passCsvDataToParent = () => {
    importData(csvData);
  };

  const deleteItem = (i: any) => {
    const dataCopy = [...csvData];
    dataCopy.splice(i, 1);

    setCsvData(dataCopy);
  };

  const handleTypeSelect = (e: any, i: any) => {
    const newType = e.target.value;

    const dataCopy = [...csvData];
    dataCopy[i].Type = newType;

    setCsvData(dataCopy);
  };

  const handleClose = () => {
    setCsvData(null);
    onClose();
  };

  return (
    <Modal className="modal-dialog-centered" isOpen={open} toggle={handleClose}>
      <div className="modal-header">
        <h5 className="modal-title">Import List Values from CSV</h5>
        <button className="close" type="button" onClick={handleClose}>
          <span aria-hidden={true}>×</span>
        </button>
      </div>
      <div className="modal-body">
        {!csvData && (
          <div className="d-flex flex-column align-items-center">
            <CSVImporter headers={["Name", "Value"]} onSuccess={storeCsvData} />
          </div>
        )}
        {csvData && (
          <div
            className="mt-3"
            style={{ overflowY: "scroll", maxHeight: 300, overflowX: "hidden" }}
          >
            <Row className="border-bottom mb-2">
              <Col>
                <h5 className="mb-0">Name</h5>
              </Col>
              <Col>
                <h5 className="mb-0">Value</h5>
              </Col>
              <Col>
                <h5 className="mb-0">Type</h5>
              </Col>
            </Row>
            {csvData.map((item: any, i: any) => (
              <Row>
                <Col>
                  <small>{item.Name}</small>
                </Col>
                <Col>
                  <small>{item.Value}</small>
                </Col>
                <Col>
                  <div className="d-flex align-items-center">
                    <Input
                      bsSize="sm"
                      type="select"
                      value={csvData[i].Type}
                      onChange={(e) => handleTypeSelect(e, i)}
                    >
                      <option value="string">String</option>
                      <option value="int">Integer</option>
                      <option value="float">Float</option>
                      <option value="boolean">Boolean</option>
                      <option value="object">JSON Object</option>
                    </Input>
                    <IconButton
                      className={"ml-2"}
                      icon="close"
                      color="danger"
                      onClick={() => deleteItem(i)}
                    />
                  </div>
                </Col>
              </Row>
            ))}
          </div>
        )}
        {error && (
          <Alert color="danger" className="w-100">
            {error}
          </Alert>
        )}
      </div>
      <div className="modal-footer">
        <Button onClick={handleClose}>Close</Button>
        <Button
          onClick={passCsvDataToParent}
          color="primary"
          disabled={!csvData || submitting}
        >
          Import
        </Button>
      </div>
    </Modal>
  );
}
